<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <el-select clearable multiple filterable class="filter-select" v-model="data[id]">
            <el-option
                v-for="(option) in dropdown"
                :key="option.id"
                :label="option.name"
                :value="option.id">
            </el-option>
        </el-select>
    </div>
</template>

<script>
    export default {
        props: [
            'name',
            'id',
            'data',
            'dropdown'
        ],
        data() {
            return {
            };
        }
    }
</script>